import React from 'react'

interface LogoTitleProps {
  icon?: React.ReactNode
  title?: string
  hideTitle?: boolean
  visible: boolean
}

export const LogoTitle = React.memo(({ icon, title, hideTitle, visible }: LogoTitleProps) => (
  <div className={`titlebar__logo-title${!visible ? ' titlebar__logo-title--hidden' : ''}`}>
    <div className="titlebar__logo">
      {icon}
    </div>
    {!hideTitle && title && (
      <span className="titlebar__title-text">{title}</span>
    )}
  </div>
))
